module.exports = __webpack_public_path__ + "static/media/bypass_left.55d92057.png";